import React from 'react'
import { shallow } from 'enzyme'
import ReactDOM from 'react-dom'
import { PriorityNotes } from '../index'
import ChecklistItems from '../features/ChecklistItems'
import Commentary from '../features/Commentary'
import Highlight from '../features/Highlight'
import Loader from '../../common/Loader'
import Error from '../../common/Error'
import HelpfulHints from '../features/HelpfulHints'

describe('PriorityNotes', () => {
  let wrapper, props, result, instance
  beforeAll(() => {
    props = {
      loanId: 123,
      currentAdmin: 1,
      isBankUser: false,
      loading: false,
      error: false,
      data: {
        loan: {
          checklistItems: [
            {
              rid: 234,
              markAsRead: true,
              description: 'Sample description'
            },
          ],
          helpfulHints: [
            {
              rid: 234,
              markAsRead: true,
              description: 'Sample description'
            },
          ],
          bankCommentaries: [
            {
              administrator: {
                rid: 1,
                name: 'SmartBiz Loans'
              },
              category: 'underwriting',
              content: 'Test Content',
              replies: [],
              rid: 45,
              state: 'published',
            }
          ],
          highlights: [
            {
              category: 'guarantor',
              topic: 'Test Content',
              draft: false,
              rid: 45,
              predefined: true,
            }
          ],
        },
      },
    },
    ReactDOM.createPortal = jest.fn((element, node) => {
      return element
    }),
    wrapper = shallow(<PriorityNotes {...props} />)
    instance = wrapper.instance()
  })

  describe('#renderChecklist', () => {
    describe('when checklistItem is passed and currentAdmin is not bankUser', () => {
      it('should render checklistItems component', () => {
        instance.renderChecklist();
        expect(wrapper.find(ChecklistItems)).toHaveLength(1)
      })
    })
    describe("when graph returns internal server error with user_session false", () => {
      it("should not render checklistItems component", () => {
        wrapper.setProps({ data: { user_session: false } });
        instance.renderChecklist();
        expect(wrapper.find(ChecklistItems)).toHaveLength(0);
      });
    });
  })
  describe('#renderHelpfulHints', () => {
    describe('when helpfulHints is passed and currentAdmin is not bankUser', () => {
      it('should render HelpfulHints component', () => {
        wrapper.setProps({ data: { ...props.data } });
        instance.renderHelpfulHints()
        expect(wrapper.find(HelpfulHints)).toHaveLength(1)
      })
    })
  })
  describe('#renderCommentaries', () => {
    describe('when bankCommentaries is passed', () => {
      it('should render Commentary component', () => {
        instance.renderCommentaries()
        expect(wrapper.find(Commentary)).toHaveLength(1)
      })
    })
  })
  describe('#renderHighlights', () => {
    describe('when highlights is passed', () => {
      it('should render Highlight component', () => {
        instance.renderHighlights()
        expect(wrapper.find(Highlight)).toHaveLength(1)
      })
    })
  })
  describe('#render', () => {
    describe('when loading is set to true', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, loading: true } })
      })
      it('should render a loader', () => {
        expect(wrapper.find(Loader)).toHaveLength(1)
      })
    })
    describe('when there is an error fetching the data', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, error: true } })
      })
      it('renders an error message', () => {
        expect(wrapper.find(Error)).toHaveLength(1)
      })
    })
    describe("when user seession expired response", () => {
      beforeEach(() => {
        wrapper.setProps({ data: { user_session : false } });
      });
      it("renders an error message", () => {
        expect(wrapper.find(Error)).toHaveLength(1);
      });
    });
  })
})